import { render, staticRenderFns } from "./DetectedLabelExclusionAddForm.vue?vue&type=template&id=0c972e18&scoped=true"
import script from "./DetectedLabelExclusionAddForm.vue?vue&type=script&lang=js"
export * from "./DetectedLabelExclusionAddForm.vue?vue&type=script&lang=js"
import style0 from "./DetectedLabelExclusionAddForm.vue?vue&type=style&index=0&id=0c972e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c972e18",
  null
  
)

export default component.exports